import { motion } from "framer-motion";

const STEPS = [
  { n: "01", title: "Free Consultation", body: "A no-pressure 30-minute call to understand your business, goals, and bottlenecks." },
  { n: "02", title: "Business Assessment", body: "We map your workflows, software stack, and the admin work draining your team." },
  { n: "03", title: "Custom Proposal", body: "You receive a written proposal — scope, hours, deliverables, security & confidentiality." },
  { n: "04", title: "Secure Onboarding", body: "We sign NDAs, set up secure access, document your processes, and brief your team." },
  { n: "05", title: "Daily Support", body: "Your dedicated team gets to work — reliable, organized, and responsive every day." },
  { n: "06", title: "Monthly Review", body: "We meet monthly to review KPIs, refine processes, and scale support as you grow." },
];

export default function Process() {
  return (
    <section id="process" className="relative py-28 lg:py-36 bg-[#0B2545] text-white overflow-hidden" data-testid="process-section">
      <div className="absolute inset-0 opacity-20 pointer-events-none">
        <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-[#16A34A] blur-3xl" />
        <div className="absolute -bottom-32 -left-32 w-96 h-96 rounded-full bg-[#16A34A] blur-3xl" />
      </div>
      <div className="container-apex relative">
        <div className="max-w-3xl">
          <div className="overline">Our Process</div>
          <h2 className="heading-display text-4xl sm:text-5xl lg:text-6xl mt-5">
            Six steps to a quieter inbox.
          </h2>
        </div>

        <div className="mt-16 relative">
          <div className="absolute left-6 md:left-1/2 top-0 bottom-0 w-px bg-white/15" />
          <div className="space-y-12 md:space-y-16">
            {STEPS.map((s, i) => (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ delay: 0.05 * i, duration: 0.6 }}
                className={`relative md:grid md:grid-cols-2 md:gap-12 items-center ${i % 2 ? "md:[direction:rtl]" : ""}`}
                data-testid={`process-step-${i + 1}`}
              >
                <div className="md:[direction:ltr] pl-16 md:pl-0">
                  <div className="text-[#16A34A] font-mono text-sm tracking-widest">STEP {s.n}</div>
                  <h3 className="font-display font-bold text-2xl md:text-4xl mt-2">{s.title}</h3>
                  <p className="mt-3 text-white/70 max-w-md">{s.body}</p>
                </div>
                <div className="absolute left-0 md:left-1/2 -translate-x-1/2 md:-translate-x-1/2 top-0 w-12 h-12 rounded-full bg-[#16A34A] flex items-center justify-center font-display font-black text-white shadow-2xl">
                  {s.n}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
